import React, { useState, useEffect } from "react";
import GridTextFilterOption from "./GridTextFilterOption";
import { useDispatch } from 'react-redux';
import signals from "../../redux/actions/signals";

function useDebouncedEffect(callback, deps, delay) {
    useEffect(() => {
        const handler = setTimeout(() => {
            callback();
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [...deps, delay]);
}

export default ({ filterOptions, addFilterValue, removeFilterValue, clearFilter, columnName }) => {
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const {
        performFuzzySearch,
    } = signals.actionCreators;

    useDebouncedEffect(() => {
        dispatch(performFuzzySearch({ columnName, searchValue: search }));
    }, [search, columnName, dispatch], 300);

    return (
        <div className="py-3 px-2">
            <input 
                className="px-2" 
                placeholder="Search filter" 
                type={'text'} 
                value={search} 
                onChange={e => setSearch(e.target.value)} 
            />
            <div className="text-end my-3">
                <button onClick={clearFilter} className="cec-btn font-12 text-end">
                    Uncheck all
                </button>
            </div>
            <ul className="m-0 p-0">
                {filterOptions.length > 0
                    ? filterOptions
                        .sort(({ value: aValue, selected: aSelected }, { value: bValue, selected: bSelected }) =>
                            aSelected
                                ? bSelected
                                    ? String(aValue).localeCompare(String(bValue))
                                    : -1
                                : bSelected
                                    ? 1
                                    : String(aValue).localeCompare(String(bValue))
                        )
                        .map(({ value, selected }) => (
                            <GridTextFilterOption 
                                {...{ value, selected, addFilterValue, removeFilterValue }} 
                            />
                        ))
                    : <li className="list-group-item p-2">No results found</li>
                }
            </ul>
        </div>
    );
};
